module.exports = __webpack_public_path__ + "img/newdynamic.379ec0a4.png";